const filters = {
  filtros: {
    placeholderSearchFacet: {
      text: 'Buscá {{facet}}',
    },
  },
}

export default filters
